type IconProps = React.SVGProps<SVGSVGElement>;

const SkiDemo: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 2C4.55228 2 5 2.44772 5 3V23H5.5C6.05228 23 6.5 23.4477 6.5 24C6.5 24.5523 6.05228 25 5.5 25H5V29C5 29.5523 4.55228 30 4 30C3.44772 30 3 29.5523 3 29V25H2.5C1.94772 25 1.5 24.5523 1.5 24C1.5 23.4477 1.94772 23 2.5 23H3V3C3 2.44772 3.44772 2 4 2ZM19 2C21.2091 2 23 3.79086 23 6V29C23 29.5523 22.5523 30 22 30H10C9.48232 30 9.05621 29.6067 9.00488 29.1025L9 29V6C9 3.79086 10.7909 2 13 2C14.195 2 15.267 2.52463 16 3.35547C16.733 2.52463 17.805 2 19 2ZM28 2C28.5523 2 29 2.44772 29 3V23H29.75C30.1642 23 30.5 23.3358 30.5 23.75C30.5 24.1642 30.1642 24.5 29.75 24.5H29V29C29 29.5523 28.5523 30 28 30C27.4477 30 27 29.5523 27 29V24.5H26.25C25.8358 24.5 25.5 24.1642 25.5 23.75C25.5 23.3358 25.8358 23 26.25 23H27V3C27 2.44772 27.4477 2 28 2ZM11 28H15V20H11V28ZM17 20V28H21V20H17ZM17 14V18H21V14H17ZM11 18H15V14H11V18ZM19 4C17.8954 4 17 4.89543 17 6V12H21V6C21 4.89543 20.1046 4 19 4ZM13 4C11.8954 4 11 4.89543 11 6V12H15V6C15 4.89543 14.1046 4 13 4Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SkiDemo;
